const RankingColumns = [
  {
    name: "Rank",
    value: "year25",
    show: true,
    isBold: true,
    colSpan: 3,
  },
  {
    name: "",
    value: "year24",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "",
    value: "changecount",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Name",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "VALUE (₹ crore)",
    value: "valueincr2025",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "valueincr2024",
    show: true,
    isBold: true,
  },
  {
    name: "Change",
    value: "changeincr",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "changeinpercentage",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "VALUE ($ billion)",
    value: "valueinbillion2025",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "valueinbillion2024",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Change",
    value: "changesinbillion",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "changesinpercentage",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "FLAGSHIP COMPANIES/HOLDINGS",
    value: "companyholding",
    show: true,
    isBold: true,
    sortable: true,
  },
  {
    name: "Sectors",
    value: "sector",
    show: true,
    isBold: true,
    sortable: true,
  },
];
const RankingSubColumns = [
  {
    name: "2025",
    value: "year25",
    show: true,
    isBold: true,
  },
  {
    name: "2024",
    value: "year24",
    show: true,
    isBold: true,
  },
  {
    name: "Change (count)",
    value: "changecount",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "2025",
    value: "valueincr2025",
    show: true,
    isBold: true,
  },
  {
    name: "2024",
    value: "valueincr2024",
    show: true,
    isBold: true,
  },
{
    name: "₹ crore",
    value: "changeincr",
    show: true,
    isBold: true,
  },
  {
    name: "%",
    value: "changeinpercentage",
    show: true,
    isBold: true,
  },
{
    name: "2025",
    value: "valueinbillion2025",
    show: true,
    isBold: true,
  },
  {
    name: "2024",
    value: "valueinbillion2024",
    show: true,
    isBold: true,
  },
  {
    name: "$ billion",
    value: "changesinbillion",
    show: true,
    isBold: true,
  },
  {
    name: "%",
    value: "changesinpercentage",
    show: true,
    isBold: true,
  },
{
    name: "",
    value: "companyholding",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "sector",
    show: true,
    isBold: true,
  },
];
const RankingColumns2026 = [
  {
    name: "Rank",
    value: "year26",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "year25",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Name",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "VALUE (₹ crore)",
    value: "valueincr2026",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "valueincr2025",
    show: true,
    isBold: true,
  },
  {
    name: "Change",
    value: "changeincr",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "changeinpercentage",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "VALUE ($ billion)",
    value: "valueinbillion2026",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "valueinbillion2025",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Change",
    value: "changesinbillion",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "changesinpercentage",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "FLAGSHIP COMPANIES/HOLDINGS",
    value: "companyholding",
    show: true,
    isBold: true,
    sortable: true,
  },
  {
    name: "Sectors",
    value: "sector",
    show: true,
    isBold: true,
    sortable: true,
  },
];
const RankingSubColumns2026 = [
  {
    name: "2026",
    value: "year26",
    show: true,
    isBold: true,
  },
  {
    name: "2025",
    value: "year25",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "2026",
    value: "valueincr2026",
    show: true,
    isBold: true,
  },
  {
    name: "2025",
    value: "valueincr2025",
    show: true,
    isBold: true,
  },
{
    name: "₹ crore",
    value: "changeincr",
    show: true,
    isBold: true,
  },
  {
    name: "%",
    value: "changeinpercentage",
    show: true,
    isBold: true,
  },
{
    name: "2026",
    value: "valueinbillion2026",
    show: true,
    isBold: true,
  },
  {
    name: "2025",
    value: "valueinbillion2025",
    show: true,
    isBold: true,
  },
  {
    name: "$ billion",
    value: "changesinbillion",
    show: true,
    isBold: true,
  },
  {
    name: "%",
    value: "changesinpercentage",
    show: true,
    isBold: true,
  },
{
    name: "",
    value: "companyholding",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "sector",
    show: true,
    isBold: true,
  },
];

export { RankingColumns, RankingSubColumns, RankingColumns2026, RankingSubColumns2026 };
